export { Image } from './image.component'
export type {
  ImageAspectRatio,
  ImageBorderRadius,
  ImageObjectFit,
  ImageProps,
} from './image.types'
